import {
  Button,
  Callout,
  Checkbox,
  Collapse,
  Dialog,
  DialogBody,
  DialogFooter,
  FormGroup,
  HotkeysProvider,
  HotkeysTarget2,
  HTMLSelect,
  Icon,
  InputGroup,
  OverlaysProvider,
  Tag,
} from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import { TableCustom } from "../../Structure/navbar/blueprintTableincludes";
import {
  mefBrand,
  mefColor,
  mefCountry,
  mefDate,
  mefPlate,
  mefVehicleClass,
} from "../../../utils/mef";
import i18n from "../../../i18n";
import { RenderMode } from "@blueprintjs/table";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import Detection from "./Detection";
import { DateInput3, TimePrecision } from "@blueprintjs/datetime2";
import i18next from "i18next";

export default function History(props) {
  const [transaction, openDetail] = useState(null);
  const [detections, setDetections] = useState(null);
  const [matching, setMatching] = useState(null);
  const [plateFilter, setPlateFilter] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [filters, setFilters] = useState({});
  const [show_filters, showFilters] = useState(false);
  const [countryFilters, setCountryFilters] = useState([]);
  const [movementFilters, setMovementFilters] = useState([]);
  const [exitedFilter, setExitedFilter] = useState("undefined");
  const [laneFilters, setLaneFilters] = useState([]);
  const [brandFilters, setBrandFilters] = useState([]);
  const [classFilters, setClassFilters] = useState([]);
  const [colorFilters, setColorFilters] = useState([]);
  const [modelFilters, setModelFilters] = useState([]);
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    authenticatedGetFetch(
      "/ow/dc/transactions/filters?srv=" + props.srv,
      (filters) => setFilters(filters)
    );
    authenticatedGetFetch("/devices?srvfilter=" + props.srv, (response) => {
      const lookup = {};
      for (const device of response)
        lookup[device.id] = <span>{device.name || device.id}</span>;
      setDevices(lookup);
    });
  }, [props.srv]);

  useEffect(() => {
    if (transaction)
      authenticatedGetFetch(
        "/ow/dc/detections?srv=" + props.srv + "&transaction=" + transaction.id,
        (detections) => setDetections(detections)
      );
    else setDetections(null);
  }, [props.srv, transaction]);

  return (
    <div>
      <Callout icon="history" title={<Trans>transaction history</Trans>}>
        <OverlaysProvider>
          {detections && (
            /* transaction view */
            <Dialog
              title={
                <span>
                  {transaction.plate && (
                    <span>
                      <span className="licenseplate">
                        {mefPlate(transaction.plate)}
                      </span>{" "}
                    </span>
                  )}{" "}
                  {mefDate(transaction.date)}
                </span>
              }
              icon="drive-time"
              isOpen={true}
              onClose={() => {
                openDetail(null);
                setDetections(null);
              }}
            >
              <DialogBody>
                {(detections?.data || []).map((d) => (
                  <span key={d.id}>
                    <Detection {...d} />
                    <br />
                  </span>
                ))}
                <HotkeysProvider>
                  <HotkeysTarget2
                    hotkeys={[
                      {
                        combo: "ArrowLeft",
                        global: true,
                        label: "Open",
                        onKeyDown: () =>
                          openDetail({
                            ...transaction,
                            id: transaction.id - 1,
                          }),
                      },
                    ]}
                  >
                    <div></div>
                  </HotkeysTarget2>
                  <HotkeysTarget2
                    hotkeys={[
                      {
                        combo: "ArrowRight",
                        global: true,
                        label: "Open",
                        onKeyDown: () =>
                          openDetail({
                            ...transaction,
                            id: transaction.id + 1,
                          }),
                      },
                    ]}
                  >
                    <div></div>
                  </HotkeysTarget2>
                </HotkeysProvider>
              </DialogBody>
              <DialogFooter
                actions={[
                  <Button
                    key="previous"
                    icon="arrow-left"
                    onClick={() =>
                      openDetail({ ...transaction, id: transaction.id - 1 })
                    }
                  />,
                  <Button
                    key="next"
                    icon="arrow-right"
                    onClick={() =>
                      openDetail({ ...transaction, id: transaction.id + 1 })
                    }
                  />,
                  <Button
                    key="close"
                    intent="primary"
                    text={<Trans>close</Trans>}
                    onClick={() => {
                      openDetail(null);
                      setDetections(null);
                    }}
                  />,
                ]}
              />
            </Dialog>
          )}
          <Button
            icon="filter-list"
            onClick={() => showFilters(!show_filters)}
          />
          <Collapse isOpen={show_filters}>
            <FormGroup
              label={
                <span>
                  <Trans>plate</Trans>
                  <Trans>:</Trans>
                </span>
              }
              labelFor="input_plate"
              inline={true}
            >
              <InputGroup
                id="input_plate"
                value={plateFilter}
                onChange={(ti) =>
                  setPlateFilter(
                    ti.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/g, "")
                  )
                }
                maxLength="12"
                leftIcon="widget-button"
              />
            </FormGroup>

            <FormGroup
              label={<Trans>from</Trans>}
              labelFor="from"
              inline={true}
            >
              <DateInput3
                id="from"
                formatDate={(date) =>
                  new Date(date).toLocaleString(i18next.language)
                }
                onChange={(date) => setFrom(date)}
                parseDate={(str) => new Date(str)}
                highlightCurrentDay={true}
                timePrecision={TimePrecision.MINUTE}
                showTimezoneSelect={false}
                showActionsBar={true}
                todayButtonText={<Trans>today</Trans>}
                clearButtonText={<Trans>clear</Trans>}
              />
            </FormGroup>

            <FormGroup label={<Trans>to</Trans>} labelFor="to" inline={true}>
              <DateInput3
                id="to"
                formatDate={(date) =>
                  new Date(date).toLocaleString(i18next.language)
                }
                onChange={(date) => setTo(date)}
                parseDate={(str) => new Date(str)}
                highlightCurrentDay={true}
                timePrecision={TimePrecision.MINUTE}
                showTimezoneSelect={false}
                showActionsBar={true}
                todayButtonText={<Trans>today</Trans>}
                clearButtonText={<Trans>clear</Trans>}
              />
            </FormGroup>

            <FormGroup label={<Trans>movement</Trans>} inline={true}>
              {[0, 1, 2].map((b) => (
                <Checkbox
                  key={"cbd" + b}
                  inline={true}
                  value={b}
                  onChange={(cb) => {
                    if (cb.target.checked)
                      setMovementFilters([...movementFilters, cb.target.value]);
                    else
                      setMovementFilters(
                        movementFilters.filter((br) => br != b)
                      );
                  }}
                >
                  <Trans>{"movement" + b}</Trans>
                </Checkbox>
              ))}
            </FormGroup>

            <FormGroup
              label={<Trans>presence</Trans>}
              labelFor="input_presence"
              inline={true}
            >
              <HTMLSelect
                id="input_presence"
                options={[
                  { value: "undefined", label: i18n.t("all") },
                  { value: "false", label: i18n.t("present") },
                  { value: "true", label: i18n.t("absent") },
                ]}
                onChange={(ti) => setExitedFilter(ti.target.value)}
              />
            </FormGroup>

            <FormGroup
              label={<Trans>lane</Trans>}
              labelFor="input_lane"
              inline={true}
            >
              {(filters?.lanes || []).map((b) => (
                <Checkbox
                  key={"cbl" + b}
                  inline={true}
                  value={b}
                  onChange={(cb) => {
                    if (cb.target.checked)
                      setLaneFilters([...laneFilters, cb.target.value]);
                    else setLaneFilters(laneFilters.filter((br) => br != b));
                  }}
                >
                  {b && (devices[b] || b)}
                </Checkbox>
              ))}
            </FormGroup>

            {(filters?.colors || []).length > 1 && (
              <FormGroup
                label={<Trans>color</Trans>}
                labelFor="input_color"
                inline={true}
              >
                {(filters?.colors || []).map(
                  (c) =>
                    c && (
                      <Checkbox
                        key={"cbc" + c}
                        inline={true}
                        value={c}
                        onChange={(cb) => {
                          if (cb.target.checked)
                            setColorFilters([...colorFilters, cb.target.value]);
                          else
                            setColorFilters(
                              colorFilters.filter((color) => color !== c)
                            );
                        }}
                      >
                        <Tag
                          style={{
                            backgroundColor: c.toLowerCase(),
                          }}
                        />
                      </Checkbox>
                    )
                )}
              </FormGroup>
            )}

            {(filters?.brands || []).length > 1 && (
              <FormGroup
                label={<Trans>brand</Trans>}
                labelFor="input_brand"
                inline={true}
              >
                {(filters?.brands || []).map(
                  (b) =>
                    b && (
                      <Checkbox
                        key={"cbb" + b}
                        inline={true}
                        value={b}
                        onChange={(cb) => {
                          if (cb.target.checked)
                            setBrandFilters([...brandFilters, cb.target.value]);
                          else
                            setBrandFilters(
                              brandFilters.filter((br) => br !== b)
                            );
                        }}
                      >
                        {mefBrand(b)}
                      </Checkbox>
                    )
                )}
              </FormGroup>
            )}

            {(filters?.classes || []).length > 1 && (
              <FormGroup
                label={<Trans>vehicle class</Trans>}
                labelFor="input_type"
                inline={true}
              >
                {(filters?.classes || []).map(
                  (m) =>
                    m && (
                      <Checkbox
                        key={"cbcl" + m}
                        inline={true}
                        value={m}
                        onChange={(cb) => {
                          if (cb.target.checked)
                            setClassFilters([...classFilters, cb.target.value]);
                          else
                            setClassFilters(
                              classFilters.filter((mo) => mo !== m)
                            );
                        }}
                      >
                        <Trans>{mefVehicleClass({ label: m })}</Trans>
                      </Checkbox>
                    )
                )}
              </FormGroup>
            )}

            {(filters?.models || []).length > 1 && (
              <FormGroup
                label={<Trans>model</Trans>}
                labelFor="input_model"
                inline={true}
              >
                {(filters?.models || []).map(
                  (m) =>
                    m && (
                      <Checkbox
                        key={"cbmo" + m}
                        inline={true}
                        value={m}
                        onChange={(cb) => {
                          if (cb.target.checked)
                            setModelFilters([...modelFilters, cb.target.value]);
                          else
                            setModelFilters(
                              modelFilters.filter((mo) => mo !== m)
                            );
                        }}
                      >
                        {m}
                      </Checkbox>
                    )
                )}
              </FormGroup>
            )}

            {(filters?.countries || []).length > 1 && (
              <FormGroup
                label={<Trans>country</Trans>}
                labelFor="input_country"
                inline={true}
              >
                {(filters?.countries || []).map(
                  (m) =>
                    m && (
                      <Checkbox
                        key={"cbco" + m}
                        inline={true}
                        value={m}
                        onChange={(cb) => {
                          if (cb.target.checked)
                            setCountryFilters([
                              ...countryFilters,
                              cb.target.value,
                            ]);
                          else
                            setCountryFilters(
                              countryFilters.filter((mo) => mo !== m)
                            );
                        }}
                      >
                        {mefCountry(m)}
                      </Checkbox>
                    )
                )}
              </FormGroup>
            )}
          </Collapse>
          <TableCustom
            url={
              "/ow/dc/transactions?" +
              new URLSearchParams({
                srv: props.srv,
              }) +
              (plateFilter ? "&plate=" + plateFilter : "") +
              (from ? "&from=" + new Date(from).toISOString() : "") +
              (to ? "&to=" + new Date(to).toISOString() : "") +
              (brandFilters.length > 0
                ? "&brands=" + brandFilters.join("&brands=")
                : "") +
              (colorFilters.length > 0
                ? "&colors=" + colorFilters.join("&colors=")
                : "") +
              (classFilters.length > 0
                ? "&classes=" + classFilters.join("&classes=")
                : "") +
              (countryFilters.length > 0
                ? "&countries=" + countryFilters.join("&countries=")
                : "") +
              (movementFilters.length > 0
                ? "&movements=" + movementFilters.join("&movements=")
                : "") +
              (exitedFilter !== "undefined" ? "&exited=" + exitedFilter : "") +
              (modelFilters.length > 0
                ? "&models=" + modelFilters.join("&models=")
                : "") +
              (laneFilters.length > 0
                ? "&lanes=" + laneFilters.join("&lanes=")
                : "")
            }
            orderBy="date"
            paging={true}
            renderMode={RenderMode.BATCH_ON_UPDATE}
            columns={[
              {
                title: <Trans>date</Trans>,
                field: "date",
                sortable: true,
                render: (raw) => mefDate(raw.date),
              },
              {
                title: <Trans>lane</Trans>,
                field: "date",
                sortable: true,
                render: (raw) => devices[raw?.lane?.id] || raw?.lane?.label,
              },
              {
                title: <Trans>movement</Trans>,
                field: "movement",
                sortable: true,
                render: (raw) => (
                  <span>
                    <Icon
                      icon={
                        raw.movement === 0
                          ? "input"
                          : raw.movement === 1
                          ? "output"
                          : "flows"
                      }
                    />{" "}
                    <Trans>{"movement" + raw.movement}</Trans>
                  </span>
                ),
              },
              {
                title: <Trans>presence</Trans>,
                field: "exited",
                sortable: true,
                render: (raw) => (
                  <span>
                    <Icon icon={raw.exited ? "cross-circle" : "tick-circle"} />{" "}
                    <Trans>{raw.exited ? "absent" : "present"}</Trans>
                  </span>
                ),
              },
              {
                title: <Trans>immat</Trans>,
                field: "plate",
                sortable: true,
                render: (raw) => mefPlate(raw.plate),
              },
              {
                title: <Trans>country</Trans>,
                field: "country",
                sortable: true,
                render: (raw) => mefCountry(raw.country),
              },
              {
                title: <Trans>color</Trans>,
                field: "vehicle_color",
                sortable: true,
                render: (raw) => mefColor(raw.vehicle_color),
              },
              {
                title: <Trans>brand</Trans>,
                field: "vehicle_brand",
                sortable: true,
                render: (raw) => (
                  <span>
                    {mefBrand(raw?.vehicle_brand)}{" "}
                    {raw?.vehicle_model && " (" + raw?.vehicle_model + ")"}
                  </span>
                ),
              },
              {
                title: <Trans>vehicle class</Trans>,
                field: "vehicle_class.id",
                sortable: true,
                render: (raw) => mefVehicleClass(raw?.vehicle_class),
              },
              {
                title: <Trans>info</Trans>,
                sortable: false,
                render: (raw) => (
                  <Tag
                    interactive={true}
                    minimal={true}
                    icon="info-sign"
                    onClick={() => openDetail(raw)}
                  />
                ),
              },
            ]}
          />
        </OverlaysProvider>
      </Callout>
      <br />
      <Callout icon="history" title={<Trans>matching attempt history</Trans>}>
        {matching && (
          <Dialog
            title={
              <span>
                {matching?.searched?.plate && (
                  <span>
                    <span className="licenseplate">
                      {mefPlate(matching.searched.plate)}
                    </span>{" "}
                  </span>
                )}{" "}
                {mefDate(matching?.searched?.date)}
              </span>
            }
            icon="drive-time"
            isOpen={true}
            onClose={() => {
              setMatching(null);
            }}
          >
            <DialogBody>
              <Callout title={<Trans>searched vehicle</Trans>}>
                {(matching?.searched?.detections || []).map((d) => (
                  <span key={d.id}>
                    <Detection {...d} />
                    <br />
                  </span>
                ))}
              </Callout>
              <Callout title={<Trans>matching found</Trans>}>
                {matching.results.map((r) =>
                  (r?.detections || []).map((d) => (
                    <span key={d.id}>
                      <Detection {...d} />
                      <br />
                    </span>
                  ))
                )}
              </Callout>
            </DialogBody>
            <DialogFooter
              actions={
                <Button
                  intent="primary"
                  text={<Trans>close</Trans>}
                  onClick={() => {
                    setMatching(null);
                  }}
                />
              }
            />
          </Dialog>
        )}
        <TableCustom
          url={"/ow/dc/matchings?srv=" + props.srv}
          orderBy="date"
          paging={true}
          renderMode={RenderMode.BATCH_ON_UPDATE}
          columns={[
            {
              title: <Trans>date</Trans>,
              field: "date",
              sortable: true,
              render: (raw) => mefDate(raw.date),
            },
            {
              title: <Trans>searched plate</Trans>,
              field: "searched.plate",
              sortable: true,
              render: (raw) => mefPlate(raw?.searched?.plate),
            },
            {
              title: <Trans>matching method</Trans>,
              field: "method",
              sortable: true,
              intent: (raw) => {
                switch (raw.method) {
                  case 0:
                    return "success";
                  case null:
                    return "danger";
                  default:
                    return "warning";
                }
              },
              render: (raw) =>
                raw.method !== null ? (
                  <>
                    <Trans>{"tolerance_level_" + raw.method}</Trans> (
                    {raw?.reliability || "?"}%)
                  </>
                ) : (
                  i18n.t("no result")
                ),
            },
            {
              title: <Trans>result</Trans>,
              sortable: false,
              intent: (raw) => {
                switch ((raw.results || []).length) {
                  case 0:
                    return "danger";
                  case 1:
                    return "success";
                  default:
                    return "warning";
                }
              },
              render: (raw) => mefPlate(raw.results[0]?.plate || ""),
            },
            {
              title: <Trans>Images</Trans>,
              sortable: false,
              render: (raw) => (
                <Tag
                  minimal="true"
                  interactive="true"
                  icon="media"
                  onClick={() => {
                    authenticatedGetFetch(
                      "/ow/dc/matching/" + raw.id + "?srv=" + props.srv,
                      (matching) => setMatching(matching)
                    );
                  }}
                />
              ),
            },
          ]}
        />
      </Callout>
    </div>
  );
}
